import { PATHS, ELEMENT_TYPE } from '../config/constants';

import designers from './designers';
import products from './products';

const webLeftDistance = '3.38vw';
const mobileLeftDistance = '5.06vw';

const webRightDistance = '93.75vw';
const mobileRightDistance = '85.61vw';

export default {
  '2040': {
    id: '2040',
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_1080/max-braun/rooms/room2040.jpg',
    title: '20s - 40s',
    links: {
      previous: {
        label: 'Present',
        path: `${PATHS.ROOM}/present`,
        id: 'present',
      },
      next: {
        label: '50s - 60s',
        path: `${PATHS.ROOM}/5060`,
        id: '5060',
      },
    },
    hotspot: {
      to: `${PATHS.DESIGNER}/HD01`,
      type: ELEMENT_TYPE.DESIGNER,
      data: designers.HD01,
      top: '13%',
      left: '80%',
      mobileTop: '10%',
      mobileLeft: '80%',
    },
    icons: [
      {
        position: {
          left: '3%',
          top: '49%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '3.334%',
          top: '58%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '15%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room2040/Cosmophon333W.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR02`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR02,
        nameIcon: 'Cosmophon  333W',
        yearIcon: '1932',
      },
      {
        position: {
          left: '27.5%',
          top: '52%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '27.5%',
          top: '60%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '23%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room2040/Manulux.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR04`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR04,
        nameIcon: 'Manulux',
        yearIcon: '1938',
      },
      {
        position: {
          left: '71%',
          top: '49%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '68%',
          top: '60%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '45%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room2040/777Ccosmophon.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR03`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR03,
        nameIcon: 'Braun Cosmophon 777C',
        yearIcon: '1932',
      },
    ],
  },
  '5060': {
    id: '5060',
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_1080/max-braun/rooms/room5060.jpg',
    title: '50s - 60s',
    links: {
      previous: {
        label: '20s - 40s',
        path: `${PATHS.ROOM}/2040`,
        id: '2040',
      },
      next: {
        label: '70s - 80s',
        path: `${PATHS.ROOM}/7080`,
        id: '7080',
      },
    },
    icons: [
      {
        position: {
          left: '3.5%',
          top: '13%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '3.334%',
          top: '21%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '15%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room5060/Stixant.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR18`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR18,
        nameIcon: 'Sixtant',
        yearIcon: '1962',
      },
      {
        position: {
          left: '11%',
          top: '35%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '11%',
          top: '43%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '23%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room5060/S50.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR05`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR05,
        nameIcon: 'S50',
        yearIcon: '1950',
      },
      {
        position: {
          left: '19.25%',
          top: '55%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '19.25%',
          top: '61%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '31%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room5060/T3.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR14`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR14,
        nameIcon: 'T3',
        yearIcon: '1958',
      },
      {
        position: {
          left: '40%',
          top: '4%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '18%',
        },
        mobilePosition: {
          left: '41%',
          top: '18%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '39%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room5060/Tp1.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR16`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR16,
        nameIcon: 'TP1',
        yearIcon: '1959',
      },
      {
        position: {
          left: '57%',
          top: '28%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '54.5%',
          top: '37%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '25%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/v1601466454/max-braun/rooms/icons/room5060/Sk4.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR12`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR12,
        nameIcon: 'SK 4',
        yearIcon: '1956',
      },
      {
        position: {
          left: '71%',
          top: '30%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '69%',
          top: '37%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '33%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/v1601466823/max-braun/rooms/icons/room5060/km3-31.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR13`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR13,
        nameIcon: 'KM 3/31',
        yearIcon: '1957',
      },
      {
        position: {
          left: '83%',
          top: '41%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '82%',
          top: '46%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '41%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room5060/ksm1-11.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR19`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR19,
        nameIcon: 'KSM 1/11',
        yearIcon: '1963',
      },
    ],
  },
  '7080': {
    id: '7080',
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_1080/max-braun/rooms/room7080.jpg',
    title: '70s - 80s',
    links: {
      previous: {
        label: '50 - 60s',
        path: `${PATHS.ROOM}/5060`,
        id: '5060',
      },
      next: {
        label: '90s - 00s',
        path: `${PATHS.ROOM}/9000`,
        id: '9000',
      },
    },
    icons: [
      {
        position: {
          left: '13.5%',
          top: '36%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '13.5%',
          top: '44%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '15%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/HLD4.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR25`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR25,
        nameIcon: 'HLD4',
        yearIcon: '1970',
      },
      {
        position: {
          left: '41%',
          top: '1%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '41%',
          top: '8%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '23%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/ET33.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR32`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR32,
        nameIcon: 'ET 33',
        yearIcon: '1977',
      },
      {
        position: {
          left: '49.5%',
          top: '2%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '49.5%',
          top: '10%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '31%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/ABW41.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR37`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR37,
        nameIcon: 'ABW41',
        yearIcon: '1981',
      },
      {
        position: {
          left: '62%',
          top: '49%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '61%',
          top: '56%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '25%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/Atelier.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR35`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR35,
        nameIcon: 'Atelier',
        yearIcon: '1980',
      },
      {
        position: {
          left: '74%',
          top: '26%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '74%',
          top: '33%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '33%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/MR6.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR36`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR36,
        nameIcon: 'MR 6',
        yearIcon: '1981',
      },
      {
        position: {
          left: '90.5%',
          top: '26%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '89.5%',
          top: '30%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '41%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/KF40.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR39`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR39,
        nameIcon: 'KF 40',
        yearIcon: '1984',
      },
      {
        position: {
          left: '95.5%',
          top: '30%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '50%',
        },
        mobilePosition: {
          left: '94.5%',
          top: '36%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '49%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/MPZ22.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR29`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR29,
        nameIcon: 'MPZ 22',
        yearIcon: '1972',
      },
    ],
  },
  '9000': {
    id: '9000',
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_1080/max-braun/rooms/room9000.jpg',
    title: '90s - 00s',
    links: {
      previous: {
        label: '70s - 80s',
        path: `${PATHS.ROOM}/7080`,
        id: '7080',
      },
      next: {
        label: 'Present',
        path: `${PATHS.ROOM}/present`,
        id: 'present',
      },
    },
    icons: [
      {
        position: {
          left: '3%',
          top: '34%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '2.5%',
          top: '40%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '15%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room9000/SyncroSystem.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR43`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR43,
        nameIcon: 'Syncro System',
        yearIcon: '1999',
      },
      {
        position: {
          left: '19.5%',
          top: '57%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '19.5%',
          top: '65%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '23%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room9000/CeramicWatch.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR49`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR49,
        nameIcon: 'BN 0171 Ceramic Watch',
        yearIcon: '2014',
      },
      {
        position: {
          left: '45%',
          top: '2%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '45%',
          top: '5%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '31%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/v1601467761/max-braun/rooms/icons/room5060/T3.png',
        animateFrom: 'left',
        linkToProduct: `${PATHS.PRODUCT}/PR45`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR45,
        nameIcon: 'T3',
        yearIcon: '1999',
      },
      {
        position: {
          left: '72.5%',
          top: '24%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '72%',
          top: '28%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '25%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room9000/Multiquick.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR47`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR47,
        nameIcon: 'Multiquick 9',
        yearIcon: '2013',
      },
      {
        position: {
          left: '79.5%',
          top: '32%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '79%',
          top: '39%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '33%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/MPZ22.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR29`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR29,
        nameIcon: 'MPZ 22',
        yearIcon: '1990',
      },
      {
        position: {
          left: '92%',
          top: '35%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '91%',
          top: '40%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '41%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room9000/KF12_40.png',
        animateFrom: 'right',
        linkToProduct: `${PATHS.PRODUCT}/PR39`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR39,
        nameIcon: 'KF12/40',
        yearIcon: '1984',
      },
    ],
  },
  present: {
    id: 'present',
    image:
      'https://res.cloudinary.com/arts/image/upload/q_auto:eco,h_1080/max-braun/rooms/roomPresent.jpg',
    title: 'Present',
    links: {
      previous: {
        label: '90s - 00s',
        path: `${PATHS.ROOM}/9000`,
        id: '9000',
      },
      next: {
        label: '20s - 40s',
        path: `${PATHS.ROOM}/2040`,
        id: '2040',
      },
    },
    icons: [
      {
        position: {
          left: '11.5%',
          top: '32%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '11%',
          top: '38%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '15%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/present/S9.png',
        animateFrom: 'left',
        linkToProduct: `/${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR48,
        nameIcon: 'S9',
        yearIcon: '2014',
      },
      {
        position: {
          left: '16%',
          top: '44%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '34%',
        },
        mobilePosition: {
          left: '16%',
          top: '49%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '23%',
        },

        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/present/LE01.png',
        animateFrom: 'left',
        linkToProduct: `/${PATHS.PRODUCT}/PR53`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR53,
        nameIcon: 'LE01',
        yearIcon: '2020',
      },
      {
        position: {
          left: '34.5%',
          top: '68%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '42%',
        },
        mobilePosition: {
          left: '33.5%',
          top: '85%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '31%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/present/IPL.png',
        animateFrom: 'left',
        linkToProduct: `/${PATHS.PRODUCT}/PR50`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR50,
        nameIcon: 'IPL',
        yearIcon: '2015',
      },
      {
        position: {
          left: '44%',
          top: '2%',
        },
        notVisiblePosition: {
          left: webLeftDistance,
          top: '50%',
        },
        mobilePosition: {
          left: '44%',
          top: '2%',
        },
        mobileFixedPosition: {
          left: mobileLeftDistance,
          top: '39%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/present/LE1.png',
        animateFrom: 'left',
        linkToProduct: `/${PATHS.PRODUCT}/PR50`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR15,
        nameIcon: 'LE1',
        yearIcon: '1959',
      },
      {
        position: {
          left: '89.5%',
          top: '41%',
        },
        notVisiblePosition: {
          left: webRightDistance,
          top: '26%',
        },
        mobilePosition: {
          left: '89.5%',
          top: '41%',
        },
        mobileFixedPosition: {
          left: mobileRightDistance,
          top: '25%',
        },
        icon:
          'https://res.cloudinary.com/arts/image/upload/max-braun/rooms/icons/room7080/MPZ22.png',
        animateFrom: 'right',
        linkToProduct: `/${PATHS.PRODUCT}/PR29`,
        type: ELEMENT_TYPE.PRODUCT,
        data: products.PR29,
        nameIcon: 'MPZ 22',
        yearIcon: '2010',
      },
    ],
  },
};
